import { useEffect, useState } from 'react'
import { FoundationsButton } from '../../GenericComponents/button'
import { FoundationsInput } from '../../GenericComponents/input'
import { FoundationsTextArea } from '../../GenericComponents/textarea'
import { useForm } from 'react-hook-form'
import { FormValidation } from '../../FormValidationsRules'
import { FoundationsEnums } from '../../enum'
import { FoundationsForm } from '../../GenericComponents/form'
import { useStore } from 'react-redux'
import { useSubmitFormMutation } from '../../Redux/contact/contactSlice'
import { Skeleton } from '../../GenericComponents/Skeleton'
import { FoundationsGenericToaster } from '../../GenericComponents/FoundationsGenericToaster'
import { useTitleContext } from "../../Hooks/useTitleContext";
import LoaderBox from '../../GenericComponents/LoaderBox'

declare let window: any
const UnicornApp = window.unicornInstance as any

export function Contact() {
    const {
        register,
        handleSubmit,
        formState: { errors },
        trigger,
    } = useForm({mode: 'onBlur',  // Change validation mode to trigger on blur
        reValidateMode: 'onBlur'})

    const { setTitle } = useTitleContext();
    setTitle("Contact Support");

    const [fullName, setFullName] = useState('')
    const [emailAddress, setEmailAddress] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [organizationName, setOrganizationName] = useState('')
    const [contactMessage, setContactMessage] = useState('')
    const [sendContact,{isLoading:ApiLoading}] = useSubmitFormMutation()
    const [responseMessage, setResponseMessage] = useState('')
    const [userStatus, setUserStatus] = useState('')
    const [Submitted, setSubmitted] = useState(false)
    const store = useStore()
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        setLoading(false)
    }, [])

    const handleBlur = async (fieldName: string) => {
        await trigger(fieldName);
    };

    const submitContact = () => {
        const requestUserInfo = {
            FullName: fullName,
            EmailAddress: emailAddress,
            PhoneNumber: phoneNumber,
            Organization: organizationName,
            Message: contactMessage,
        }
        setResponseMessage('')
        sendContact(requestUserInfo)
            .unwrap()
            .then((response) => {
                if (response != null) {
                    var resultData = response.data
                    if (resultData != null && resultData.MessageResults.length > 0) {
                        resultData.MessageResults.forEach(
                            (msg: { HelpMessage: FoundationsEnums.Status; Message: any }) => {
                                //setResponseMessage(msg.Message)
                                //setUserStatus(response.data.userStatus)
                                setSubmitted(true)
                            }
                        )
                    } else {
                        FoundationsGenericToaster('error', 'Something went wrong')
                    }
                }
            })
            .catch(
                (request: {
                    responseJSON: {
                        hints: React.SetStateAction<string>
                        statusMessage: React.SetStateAction<string>
                    }
                }) => {
                    setResponseMessage(
                        request.responseJSON?.hints
                            ? request.responseJSON.hints
                            : request.responseJSON?.statusMessage
                    )
                    setSubmitted(false)
                }
            )
    }

    return (
        <>
            {Submitted ? (
                <ContactSuccess />
            ) : (
                <FoundationsForm
                    id="contact_form"
                    submitFunction={submitContact}
                    handleSubmit={handleSubmit}
                >
                    <div className="row">
                        <div className="col-12 col-md-10 col-lg-10 mx-auto" id="contact_form_el">
                            <Skeleton loading={loading} className="contact-form">
                                <div className="row">
                                    <div className="col-12 mb-5 text-left">
                                        <div className="header">Contact Support</div>
                                        <div className="sub-header padding-top-small">
                                            If you have any problems using Foundations, please
                                            contact support using this form and we will help you
                                            out.
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-12" style={{ padding: '10px' }}>
                                        <FoundationsInput
                                            value={fullName}
                                            onInput={(e: { target: { value: string } }) => {
                                                setFullName(e.target?.value)
                                            }}
                                            onBlur={() => handleBlur('FullName')}
                                            id="contact_fullName"
                                            name="contact_fullName"
                                            type="text"
                                            maxLength={80}
                                            labelText="Full Name:"
                                            labelClasses="col-md-4 text-left"
                                            inputClasses="contact-inputs col-xl-8"
                                            containerClasses="col-md-8 float-right"
                                            registerFunction={register}
                                            registerName="FullName"
                                            registerRules={FormValidation.ContactUsfullName} //todo add validation
                                            error={errors.FullName?.message}
                                        />
                                    </div>
                                    <div className="col-12" style={{ padding: '10px' }}>
                                        <FoundationsInput
                                            value={emailAddress}
                                            onInput={(e: { target: { value: string } }) => {
                                                setEmailAddress(e.target?.value)
                                            }}
                                            onBlur={() => handleBlur('EmailAddress')}
                                            id="contact_emailAddress"
                                            name="contact_emailAddress"
                                            type="text"
                                            labelText="Email Address:"
                                            labelClasses="col-md-4 text-left"
                                            inputClasses="contact-inputs col-xl-8"
                                            containerClasses="col-md-8 float-right"
                                            registerFunction={register}
                                            registerName="EmailAddress"
                                            registerRules={FormValidation.email}
                                            error={errors.EmailAddress?.message}
                                        />
                                    </div>
                                    <div className="col-12" style={{ padding: '10px' }}>
                                        <FoundationsInput
                                            value={phoneNumber}
                                            onInput={(e: { target: { value: string } }) => {
                                                setPhoneNumber(e.target?.value)
                                            }}
                                            onBlur={() => handleBlur('PhoneNumber')}
                                            id="contact_phoneNumber"
                                            name="contact_phoneNumber"
                                            type="text"
                                            labelText="Phone Number: "
                                            optional={true}
                                            labelClasses="col-md-4 text-left"
                                            inputClasses="contact-inputs col-xl-8"
                                            containerClasses="col-md-8 float-right"
                                            registerFunction={register}
                                            registerName="PhoneNumber"
                                            registerRules={FormValidation.ContactNumber}
                                            error={errors.PhoneNumber?.message}
                                        />
                                    </div>
                                    <div className="col-12" style={{ padding: '10px' }}>
                                        <FoundationsInput
                                            value={organizationName}
                                            onInput={(e: { target: { value: string } }) => {
                                                setOrganizationName(e.target?.value)
                                            }}
                                            onBlur={() => handleBlur('Organization')}
                                            id="contact_orgName"
                                            name="contact_orgName"
                                            type="text"
                                            labelText="Organization Name: "
                                            optional={true}
                                            labelClasses="col-md-4 text-left"
                                            inputClasses="contact-inputs col-xl-8"
                                            containerClasses="col-md-8 float-right"
                                            registerFunction={register}
                                            registerName="Organization"
                                            registerRules={FormValidation.Contactus_OrganizationName}
                                            error={errors.Organization?.message}
                                        />
                                    </div>
                                    <div className="col-12" style={{ padding: '10px' }}>
                                        <FoundationsTextArea
                                            value={contactMessage}
                                            onInput={(e: { target: { value: string } }) => {
                                                setContactMessage(e.target?.value)
                                            }}
                                            onBlur={() => handleBlur('Message')}
                                            id="contact_message"
                                            name="contact_message"
                                            type="text"
                                            maxLength={256}
                                            labelText="Message:"
                                            labelClasses="col-md-4 text-left"
                                            inputClasses="contact-inputs col-xl-8"
                                            containerClasses="col-md-8 float-right"
                                            registerFunction={register}
                                            placeHolder="Enter your message here"
                                            registerName="Message"
                                            registerRules={FormValidation.contactus_message}
                                            error={errors.Message?.message}
                                        />
                                    </div>
                                    <div
                                        className="col-4"
                                        style={{ padding: '10px', marginLeft: '150px'}}
                                    >
                                 
                                        <FoundationsButton
                                            type="submit"
                                            id="button_contact"
                                            classes="float-right"
                                            buttonClasses="ui-button ui-corner-all ui-widget app-button"
                                            isLoading={false}
                                            loaderClasses="app-account-loading w-90 d-block"
                                            // onClick={() => alert('hang in there! We are working on it')}
                                        >
                                            Send Message
                                        </FoundationsButton>
                                      {ApiLoading?<LoaderBox style={{position:'relative',left:'425px', top:'7px'}}/>:null}
                                     
                                    </div>
                                </div>
                            </Skeleton>
                        </div>
                    </div>
                </FoundationsForm>
            )}
        </>
    )
}

function ContactSuccess() {
    return (
        <>
            <div className="row">
                <div className="col-8" id="contact_success_el">
                    <div className="row text-left">
                        <div className="col-12 mb-5">
                            <div className="header">Contact Support</div>
                            <div className="status-box-success">
                                We have successfully received your support request.
                            </div>
                        </div>
                        <div className="col-12">
                            Thank you for contacting Foundations support. We will get in touch with
                            you as soon as possible.
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Contact
